<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">主页</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <!-- 风险提示 -->
    <div class="risk-blobk ub ub-ac ub-pc" v-if="to_risk" >
        <div class="risk ub ub-pc ub-ac2">
          <div class="warn ub ub-ac ub-pc">!</div>
          <span>{{ user.risk_tip }}</span>
          <div class="close ub ub-ac ub-pc" @click="close_risk()"><img src="../assets/img/移除.png" alt=""></div>
        </div>
    </div>
    
    <div class="back-img" :style="{ 'background-image': 'url(' + user.pic_back + ')' }"></div>


    <div class="info-block ub">
      <div @click="show_full(user.photo)">
        <img :src="user.photo" class="photo-img" />
      </div>

      <div class="info-nike">
        <div class="info_block ub ub-pc">
          <span class="nike-txt">{{ user.nick }}</span>
          <span v-if="vip_tag != ''" :class="{'vip-base':true, 'svip':vip_tag=='SVIP' ,'vip':vip_tag=='VIP'}">
              <i>{{vip_tag}}</i>
          </span>
          <span class="chatMny_tag ub ub-ac ub-pc" >聊天收费:{{ chat_mny_score_tag }}/条</span>
        </div>

        <div class="info_block ub ub-pc">
          <div class="age-tag ub ub-pc ub-ac" v-if="user.sex == '女生'">
            <img src="../assets/img/女2.png" class="sex-img" />
            <span class="age-txt">18-23岁</span>
          </div>
          <div class="age-tag2 ub ub-pc ub-ac" v-if="user.sex == '男生'">
            <img src="../assets/img/男2.png" class="sex-img" />
            <span class="age-txt">18-23岁</span>
          </div>
          <span class="location ub ub-pc ub-ac" v-if="user.loc_province != '' && user.loc_city != ''">
            {{user.loc_province.length > 6 ?user.loc_province.substr(0, 5) + "..." : user.loc_province }}&nbsp;
            {{user.loc_city.length > 6 ?user.loc_city.substr(0, 5) + "..." : user.loc_city }}&nbsp;
            {{user.loc_area}}
          </span>
          
        </div>

        <div class="info_block ub ub-pc">
          <span class="inst_tag ub ub-pc ub-ac" v-for="(item, index) in user.inst_tag" :key="index" >
            #{{ item }}
          </span>
          
        </div>
      </div>
    </div>

    <div class="charm-block">
      <div class="block ub ub-ac1">
        <div class="ub ub-ver ub-pc" style="border-right: 1px solid #dfdfdf">
          <span class="txt-heroism">{{ user.show_coin }}</span>
          <span class="txt">豪气值</span>
        </div>
        <div class="ub ub-ver ub-pc">
          <span class="txt-charm">{{ user.show_score }}</span>
          <span class="txt">魅力值</span>
        </div>
        <div class="ub ub-ver ub-pc" style="border-left: 1px solid #dfdfdf">
          <span class="txt-friend">{{ user.friend_num }}</span>
          <span class="txt">好友数</span>
        </div>
      </div>
    </div>

    <div class="item-block" v-if="false">
      <div class="item ub ub-pc ub-ac2" >
        <div class="ub ub-pc">
          <img src="../assets/img/微信3.png" class="wechat-img" />
          <span class="item-txt">微信号</span>
          <span :class="user.wx=='暂未绑定'?'item-wx-no':'item-wx'" style="margin-right: 1em;">{{ user.wx }}</span>
          
          <div class="rz-tag ub ub-pc ub-ac" v-if="user.wx_check=='通过'">
            <img src="../assets/img/认证标识.png" class="rz-img" />
            <span class="rz-txt">真实微信</span>
          </div>

          <div class="rz-tag2 ub ub-pc ub-ac" v-if="user.wx_check!='通过'">
            <img src="../assets/img/认证标识2.png" class="rz-img" />
            <span class="rz-txt2">未认证</span>
          </div>
        </div>

        <span class="look-btn">查看</span>
      </div>
    </div>

    <div class="list-block">
      <div class="list ub ub-pc ub-ac2" @click="goto_photo_album_detail()">
        <div class="ub ub-pc">
          <img src="../assets/img/new2024/picture.png" class="list-img" >
          <span class="item-txt">相册</span>
        </div>

        <div class="ub ub-pc ub-ac">
          <div class="photo-album" v-for="(item, index) in arr_pic" :key="index" :style="{ 'background-image': 'url(' + item.url + ')'}"></div>

          <span class="more" v-if="arr_pic.length > 0" >更多</span>
          <span class="more" v-if="arr_pic.length <= 0" >暂无</span>
          <img src="../assets/img/箭头2.png" class="arrow-img" />
        </div>
      </div>
    </div>

    <div class="list-block">
      <div class="list ub ub-pc ub-ac2" @click="goto_offer_list(topic_uid)">
        <div class="ub ub-pc">
          <img src="../assets/img/贡献4.png" class="list-img" />
          <span class="item-txt">魅力贡献榜</span>
        </div>

        <div class="ub ub-pc">
          <img :src="item.photo" class="pto-img"  v-for="(item, index) in arr_user" :key="index" :class="index==0 ? 'pto-img-one' : 'pto-img'"/>

          <img src="../assets/img/箭头2.png" class="arrow-img" />
        </div>
      </div>
    </div>

    <div class="gift-block">
      <li class="gift ub ub-ac1" v-for="(item, index) in ary_gift" :key="index">
        <div class="ub ub-ver ub-pc" v-for="sub_item in item" :key="sub_item.id">
          <img :src="sub_item.url" class="gift-img" />
          <span class="number">×{{ gift_sum[sub_item.name] }}</span>
        </div>
      </li>
    </div>

    <ul class="bottom-block ub" @click="goto_chat()">
      <li class="ub ub-pc ub-ac" style="border-right: 1px solid #dfdfdf">
        <img src="../assets/img/加好友.png" class="bottom-img" />
        <span class="bottom-txt">加好友</span>
      </li>

      <li class="ub ub-pc ub-ac" style="">
        <img src="../assets/img/礼物.png" class="bottom-img2" />
        <span class="bottom-txt">送礼物</span>
      </li>

      <li class="ub ub-pc ub-ac" style="border-left: 1px solid #dfdfdf">
        <img src="../assets/img/私信.png" class="bottom-img2" />
        <span class="bottom-txt">私信</span>
      </li>
    </ul>
    <full_pic ref="myFullPic"></full_pic>
  </div>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import full_pic from "../components/Full_Pic.vue";
export default {
  components: {
    full_pic: full_pic
  },
  data() {
    return {
      topic_uid: "",
      user: {
        photo: require("../assets/img/头像.jpg"),
        nick: "***",
        sex: "女生",
        age_range: "18-23岁",
        loc_province: "**省",
        loc_city: "**市",
        loc_area: "**区",
        inst_tag: ["***", "***"],
        show_coin: 0,
        show_score: 0,
        friend_num: 0,
        wx: "暂未绑定",
        wx_check: "",
        pic_back:"",
        risk_tip: ""
      },
      gift_sum: {
        棒棒糖: 0,
        鲜花: 0,
        黄瓜: 0,
        啪啪啪: 0,
        幸运星: 0,
        巧克力: 0,
        气球: 0,
        口红: 0,
        香水: 0,
        包包: 0,
        钻戒: 0,
        水晶鞋: 0,
        皇冠: 0,
        法拉利: 0,
        飞机: 0,
        火箭: 0,

        中秋月饼: 0,
        小红旗: 0,
      },
      ary_gift: [],
      gift_total: 0,
      arr_user:[],
      arr_pic: [],
      

      vip_tag: "",

      theme_dark: false,
      chat_mny_score_tag: "免费",
      to_risk: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_chat() {
      this.$router.push({ name: "chart", params: { uid: this.topic_uid } });
    },
    goto_offer_list(uid) {
      //this.$router.push({ name: "offer_list", params: { topic_uid: uid } });
    },
    goto_photo_album_detail() {
      if (this.arr_pic.length <= 0) {
        this.$toast.center("对方暂无相册~");
      } else {
        this.$router.push({ name: "photo_album_detail", params: { uid: this.topic_uid }});
      }
      
    },
    
    init_page() {
      //接收参数
      if (this.$route.params.topic_uid) {
        this.topic_uid = this.$route.params.topic_uid;
        this.$store.commit("set_topic_uid", this.topic_uid);
      } else {
        this.topic_uid = this.$store.state.topic_uid;
      }
      // var uid = this.$store.state.uid;
      // this.uid=uid;
      //加载数据

      var self = this;
      self.act_reload_userinfo({
        uid: this.topic_uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user.uid = u.uid;
          self.user.photo = u.photo;
          self.user.nick = u.nick;
          self.user.sex = u.sex;
          self.user.age_range = u.age_range;
          self.user.loc_province = u.loc_province;
          self.user.loc_city = u.loc_city;
          self.user.loc_area = u.loc_area;
          self.user.inst_tag = u.inst_tag.split("|");
          self.user.show_coin = u.coin_total;
          self.user.show_score = u.score_total;
          if (u.chat_mny_score == 0) {
            self.chat_mny_score_tag = "免费";
          } else {
            self.chat_mny_score_tag = u.chat_mny_score + "金币";
          }
          if (u.show_coin > 0) {
            self.user.show_coin = u.show_coin;
          }
          if (u.show_score > 0) {
            self.user.show_score = u.show_score;
          }
          self.user.friend_num = u.friend_num;
          self.vip_tag = u.vip_tag;
          self.user.wx = u.wx == "" ? "暂未绑定" : u.wx;
          self.user.wx_check = u.wx_check;
          self.user.pic_back = u.pic_back;
          if(self.user.pic_back ==""){
             self.user.pic_back="http://appdata.jscx666.cn/photo/bg_img/1.jpg";
          }
          self.user.risk_tip = u.risk_tip;
          if (u.risk_tip) {
            self.to_risk = true; //风险标识
            setTimeout(()=> {
              self.to_risk = false;
            },3000)
          }
          
        },
      });

      self.get({
        url: "/App/GetGiftSum/?uid=" + this.topic_uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (
                data[i].gift_name == "棒棒糖" ||
                data[i].gift_name == "中秋月饼" ||
                data[i].gift_name == "小红旗"
              ) {
                self.gift_sum["棒棒糖"] += data[i].c;
                self.gift_sum["中秋月饼"] += data[i].c;
                self.gift_sum["小红旗"] += data[i].c;
                self.gift_total += data[i].c;
              } else {
                self.gift_sum[data[i].gift_name] = data[i].c;
                self.gift_total += data[i].c;
              }
            }
          }
        },
      });


      var const_data = this.$store.state.const_data;
      this.ary_gift = tool.slice_arry(const_data.gift_1.concat(const_data.gift_2), 4);

      self.get({
        url: "/App/GetOffer_List/?uid=" + this.topic_uid,
        success: function (data) {
          for(var i in data){
          data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
          self.arr_user=data;
        },
      });

      this.get({
        url: "/App/Get_AlbumTop_Other/?uid=" + this.topic_uid + "&num=" + 3,
        success: function (data) {
          for(var i in data) {
            data[i].url = self.$store.state.url + "/photo/" + data[i].url;
          }
          self.arr_pic= data;
        },
      });

    },
    
    show_full(url) {
      this.$refs.myFullPic.show(url);
    },

    close_risk() {
      this.to_risk = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.nav-top {
  background-color: transparent;
}

.risk-blobk {
  position: fixed;
  top: 3rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  .risk {
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    width: 90%;
    background-color: #db8e8e;
    border-radius: 0.3rem;
    .warn {
      margin-right: 0.5rem;
      width: 1.5rem;
      height: 1.5rem;
      background-color: red;
      border-radius: 50%;
      font-size: 1rem;
      line-height: 1rem;
      color: #fff;
    }
    span {
      display: block;
      width: 80%;
      font-size: 0.9rem;
      color: #666;
    }
    .close {
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
}

.back-img {
  margin-top: -2.6rem;
  background-size: cover;
  background-position: center;
  height: 16rem;
}

.info-block {
  padding: 0 1rem;
  margin-top: -2.1rem;
  .photo-img {
    width: 4.3rem;
    height: 4.3rem;
    border-radius: 50%;
    border: 3px solid #fff;
    pointer-events: none;
  }
  .info-nike {
    margin-top: 1.8rem;
    font-size: 1rem;
    margin-left: 0.6rem;
    .info_block {
      margin-top: 0.3rem;
    }
    .nike-txt {
      color: #333;
    }
    .chatMny_tag {
      margin-left: 0.5rem;
      padding: 0.02rem 0.3rem;
      height: 1.2rem;
      border-radius: 0.8rem;
      background-color: #b8b8b8;
      font-size: 0.6rem;
      color: #fff;
    }
    .inst_tag {
      margin-right: 0.3rem;
      font-size: 0.75rem;
      color: #ba61ff;
    }
  }
  .age-tag {
    padding:.02rem .3rem;
    height: 1.1rem;
    border-radius: 0.6rem;
    background-color: #eccaf2;
    color: #fff;
  }
  .age-tag2 {
    padding:.02rem .3rem;
    height: 1.1rem;
    border-radius: 0.6rem;
    background-color: #8bb7f3;
    color: #fff;
  }
  .sex-img {
      width: 0.4rem;
      height: .6rem;
      margin-right: .2rem;
      pointer-events: none;
    }
  .age-txt {
    font-size: 0.75rem;
  }
  .location {
    margin-left: .5rem;
    padding: 0.02rem 0.3rem;
    height: 1.2rem;
    border-radius: 0.8rem;
    background-color: #4a9c7b;
    font-size: 0.6rem;
    color: #fff;
  }
}

.charm-block {
  padding: 0.8rem 0.8rem 0 0.8rem;
  .block {
    padding: 0.5rem 0;
    border-top: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
    .txt-heroism {
      font-size: 1.35rem;
      color: #ffa600e0;
      font-weight: 600;
    }
    .txt-charm {
      font-size: 1.35rem;
      color: #e92162;
      font-weight: 600;
    }
    .txt-friend {
      font-size: 1.35rem;
      color: rgb(186, 97, 255);
      font-weight: 600;
    }
    .txt {
    font-size: 0.8rem;
    color: #333;
    margin-top: 0.3rem;
  }
  }
  .block div {
    width: 33.3%;
  }
}

.item-block {
  padding: 0 0.8rem 0 0.8rem;
  .item {
    padding: 0.3rem 0 1.1rem 0;
    border-bottom: 1px solid #dfdfdf;
    .wechat-img {
      width: 1.5rem;
      height: 1.5rem;
      pointer-events: none;
    }
    .item-wx-no{
      font-size: 0.9rem;
      margin-left: 0.5rem;
      color: #9e9e9e;
    }
    .item-wx{
      font-size: 0.9rem;
      margin-left: 0.5rem;
      color: #1fbd6b;
    }
    .rz-tag{
      background-color: #e1f3fd;
      padding: 0 .5rem 0 0;
      border-radius: .55rem;
    }
    .rz-img {
      width: 1.2rem;
      height: 1.2rem;
      pointer-events: none;
    }
    .rz-txt {
      font-size: 0.7rem;
      color: #4bb5f7;
      font-weight: 600;
    }
    .rz-tag2{
      background-color: #e0dfdf;
      padding: 0 .5rem 0 0;
      border-radius: .55rem;
    }
    .rz-txt2{
      font-size: 0.7rem;
      color: #9e9e9e;
      font-weight: 600;
    }
    .look-btn {
      padding: 0.1rem 0.5rem;
      border-radius: 0.5rem;
      border: 1px solid #1fbd6b;
      color: #1fbd6b;
      font-size: .85rem;
      line-height: 1.6rem;
    }
  }
  .item-txt {
    font-size: 0.9rem;
    margin-left: 0.5rem;
    color: #333;
  }
}

.list-block {
  padding: 0.43rem 0.8rem 0 0.8rem;
  .list {
    padding: 0 0 0.43rem 0;
    border-bottom: 1px solid #dfdfdf;
    .list-img {
      width: 1.5rem;
      height: 1.5rem;
      pointer-events: none;
    }
    .item-txt {
      font-size: 0.9rem;
      margin-left: 0.5rem;
      color: #333;
    }
    .photo-album {
      margin: 0 0.5rem;
      width: 4rem;
      height: 4rem;
      border-radius: 0.3rem;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .more {
      font-size: 0.9rem;
      color: #333;
    }
    .arrow-img {
      margin-left: 0.5em;
      width: 1.5em;
      height: 1.5em;
      pointer-events: none;
    }
    .pto-img {
      border-radius: 50%;
      width: 2.6rem;
      height: 2.6rem;
      margin-left: .5rem;
      pointer-events: none;
    }
    .pto-img-one{
      border: 3px solid #ffd700;
    }
  }
}

.gift-block {
  padding: 0.8rem 0.5rem 4rem 0.5rem;
  .gift {
    margin-bottom: 0.5rem;
    .gift-img {
      width: 3rem;
      height: 3.35rem;
      pointer-events: none;
    }
    .number {
    color: #e92162;
    margin-top: 0.3rem;
  }
  }
}

.bottom-block {
  padding: 0.5rem 0 0 0;
  height: 4rem;
  width: 100%;
  bottom: 0;
  position: fixed;
  background-color: white;
  li {
    width: 33.3%;
    height: 2.5rem;
  }
  .bottom-img {
    width: 1.65rem;
    height: 1.4rem;
    pointer-events: none;
  }
  .bottom-img2 {
    width: 1.5rem;
    height: 1.4rem;
    pointer-events: none;
  }
  .bottom-txt {
    margin-left: 0.5rem;
    font-size: 0.9rem;
    color: #444;
  }
}

//夜间模式
.container-dark {
  background-color: #2F2E33;
  .info-block {
    .info-nike {
      .nike-txt {
        color: #DFDFDF;
      }
    }
  }

  .charm-block {
    .block {
      border-top: 1px solid #404040;
      border-bottom: 1px solid #404040;
      .b-r {
        border-right: 1px solid #404040;
      }
      .b-l {
        border-left: 1px solid #404040
      }
      .txt {
        color: #DFDFDF;
      }
    }
  }

  .list-block {
    .list {
      border-bottom: 1px solid #404040;
      .item-txt {
        color: #DFDFDF;
      }
      .more {
        color: #DFDFDF;
      }
    }
  }

  .bottom-block {
    background-color: #2c2b30;
    .b-r {
      border-right: 1px solid #404040;
    }
    .b-l {
      border-left: 1px solid #404040
    }
    .bottom-txt {
      color: #DFDFDF;
    }
  }
}
</style>